import {
	boardUrl,
	mobileNavIconForum,
	mobileNavIconFriend,
	mobileNavIconVideo,
	mobileNavIconVip
} from "../../config/config";

const MobileNavItems = [
	{
		title: 'Diễn đàn',
		url: `${boardUrl}/forums`,
		icon: mobileNavIconForum
	},
	{
		title: 'Xem Videos',
		url: `${boardUrl}/videos`,
		icon: mobileNavIconVideo
	},
	{
		title: 'Bạn bè',
		url: `${boardUrl}/videos/friends`,
		icon: mobileNavIconFriend
	},
	{
		title: 'VIP',
		url: `${boardUrl}/videos/vip`,
		icon: mobileNavIconVip
	}
];

const MobileNav = () => {
	return (
		<div className="mobile-nav fixed bottom-0 left-0 right-0 w-full z-50 lg:hidden">
			<div className="mobile-nav-inner flex items-center justify-between pt-2 pb-4 px-4">
				{MobileNavItems.map((item, i) => (
					<a key={i} href={item.url} className="flex flex-col items-center">
						<img src={item.icon} alt={item.title} className="w-12 h-12 mb-1" />
						<span className="text-xs text-white font-semibold">{item.title}</span>
					</a>
				))}
			</div>
		</div>
	);
}

export default MobileNav;